export default __webpack_public_path__ + "static/media/Group8893.16baf9d6.svg";